import { ProductActionType } from '../../../../../core/enums/product-actions/product-action-type.enum';
import { DashboardForms } from '../../../../../core/models/dashboard-forms.model';
import { ProductWithBarcode } from '../../../../../core/models/product-with-barcode.model';
import { DashboardService } from '../../../../../core/services/dashboard.service';
import { ProductForm } from '../../../../../forms/forms/product.form';

export abstract class DashboardActionDialogComponent {
  constructor(protected service: DashboardService) {}

  get forms(): DashboardForms {
    return this.service.forms;
  }

  get productActionType(): ProductActionType {
    return this.service.state.productActionType;
  }

  get productForm(): ProductForm {
    return this.forms.product;
  }

  protected get product(): ProductWithBarcode | undefined {
    return this.service.product;
  }

  protected setProductActionType(productActionType: ProductActionType) {
    this.service.state.productActionType = productActionType;
  }
}
